/*
 * This is the config state shared between different instances of the same widget type, and is saved in the layout
 */
import {
    initialPortfolioSummarySharedConfigurationState,
    PortfolioSummarySharedConfigurationState,
} from 'widgets/portfolioSummary/store/sharedConfiguration/PortfolioSummarySharedConfigurationState';

export interface WidgetsSharedConfigState {
    portfolioSummary: PortfolioSummarySharedConfigurationState;
}

export const initialWidgetsSharedConfigState = {
    portfolioSummary: initialPortfolioSummarySharedConfigurationState,
};
